import React from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ProtectedRoute } from "./ProtectedRoute";
import { SignIn } from "./screens/SignIn";
import { Dashboard } from "./screens/Dashboard";
import { AdvancedSearch } from "./screens/AdvancedSearch";
import { AdvanceResult } from "./screens/AdvanceResult";
import { GiftCard } from "./screens/GiftCard";
import { Punchh } from "./screens/Punchh";
import { MasterProfile } from "./screens/MasterProfile";
import { Olo } from "./screens/Olo";
import { AuthProvider } from "./AuthContext";
import { DashboardRSadmin } from "./screens/DashboardRSadmin";
import { NotAuthorized } from "./screens/NotAuthorized";
import { ForgotPassword } from "./screens/ForgotPassword";
import { EnterCode } from "./screens/EnterCode";
import { ResetPassword } from "./screens/ResetPassword";
import { CDP } from "./screens/CDP";
import { Cognito } from "./screens/Cognito";
import { ZaxbysAdmin } from "./screens/ZaxbysAdmin";
import { AppSnackbarProvider } from "./components/AppSnackbarProvider";

const router = createBrowserRouter([
  {
    path: "/",
    element: <SignIn />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/entercode",
    element: <EnterCode />,
  },
  {
    path: "/resetpassword",
    element: <ResetPassword />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboardrsadmin",
    element: (
      <ProtectedRoute allowRoles={["rs-admin-group", "medley-admin-group"]}>
        <DashboardRSadmin />
      </ProtectedRoute>
    ),
  },
  {
    path: "/advancedsearch",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <AdvancedSearch />
      </ProtectedRoute>
    ),
  },
  {
    path: "/advanceresult",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <AdvanceResult />
      </ProtectedRoute>
    ),
  },
  {
    path: "/giftcard",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
        ]}
      >
        <GiftCard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/punchh",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <Punchh />{" "}
      </ProtectedRoute>
    ),
  },
  {
    path: "/masterprofile",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <MasterProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/olo",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <Olo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/cognito",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <Cognito />{" "}
      </ProtectedRoute>
    ),
  },
  {
    path: "/zaxbysadmin",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
          "compliance-group"
        ]}
      >
        <ZaxbysAdmin />
      </ProtectedRoute>
    ),
  },
  
  {
    path: "/cdp",
    element: (
      <ProtectedRoute
        allowRoles={[
          "guest-experience-group",
          "guest-experience-manager-group",
          "medley-admin-group",
        ]}
      >
        <CDP />{" "}
      </ProtectedRoute>
    ),
  },
  {
    path: "/unauthorized",
    element: <NotAuthorized />,
  },
]);

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppSnackbarProvider>
          <RouterProvider router={router} />
        </AppSnackbarProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;
